var _path, _path2, _path3, _path4, _mask, _path5, _path6, _ellipse, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _g, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonEclipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 952,
    height: 907,
    viewBox: "0 0 952 907",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M821.373 689.621C815.726 764.532 750.452 820.287 675.579 814.154C600.706 808.02 544.587 742.321 550.234 667.41C555.881 592.499 621.155 536.743 696.028 542.877C770.901 549.01 827.019 614.71 821.373 689.621Z",
    fill: "url(#paint0_linear_239_632)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M792.112 685.484C792.88 738.828 750.888 774.696 698.32 765.598C645.752 756.5 602.514 705.881 601.746 652.537C600.978 599.193 642.97 563.325 695.538 572.423C748.106 581.521 791.344 632.14 792.112 685.484Z",
    fill: "url(#paint1_radial_239_632)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M784.583 721.045C795.731 781.61 757.687 814.106 699.61 793.627C641.532 773.148 585.413 707.448 574.265 646.883C563.117 586.318 601.161 553.822 659.238 574.301C717.316 594.78 773.435 660.48 784.583 721.045Z",
    fill: "url(#paint2_radial_239_632)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M784.201 721.115C789.761 751.317 783.039 774.419 767.804 787.433C752.569 800.446 728.7 803.473 699.739 793.261C670.779 783.049 642.284 761.552 619.634 735.035C596.984 708.518 580.206 677.013 574.647 646.813C569.087 616.611 575.809 593.509 591.044 580.496C606.279 567.482 630.148 564.455 659.109 574.667C688.069 584.879 716.564 606.376 739.214 632.893C761.864 659.41 778.642 690.916 784.201 721.115Z",
    stroke: "url(#paint3_linear_239_632)",
    strokeOpacity: 0.2,
    strokeWidth: 0.776366
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_239_632",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M760.126 735.919C760.539 729.467 759.955 722.262 758.267 714.395C748.474 668.759 705.237 618.141 661.693 601.334C654.187 598.437 647.162 596.734 640.725 596.133C637.271 552.837 667.365 531.458 712.258 548.011C760.991 565.981 808.709 621.845 818.839 672.788C828.171 719.717 802.35 746.099 760.126 735.919Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M760.126 735.919C760.539 729.467 759.955 722.262 758.267 714.395C748.474 668.759 705.237 618.141 661.693 601.334C654.187 598.437 647.162 596.734 640.725 596.133C637.271 552.837 667.365 531.458 712.258 548.011C760.991 565.981 808.709 621.845 818.839 672.788C828.171 719.717 802.35 746.099 760.126 735.919Z",
    fill: "url(#paint4_linear_239_632)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M758.267 714.395L757.508 714.558L758.267 714.395ZM760.126 735.919L759.351 735.869L759.31 736.52L759.944 736.673L760.126 735.919ZM661.693 601.334L661.414 602.059L661.414 602.059L661.693 601.334ZM640.725 596.133L639.952 596.195L640.003 596.845L640.653 596.906L640.725 596.133ZM712.258 548.011L711.989 548.74L712.258 548.011ZM818.839 672.788L818.078 672.94L818.839 672.788ZM757.508 714.558C759.183 722.366 759.759 729.499 759.351 735.869L760.901 735.968C761.319 729.434 760.726 722.157 759.026 714.232L757.508 714.558ZM661.414 602.059C683.035 610.404 704.63 627.168 722.046 647.558C739.462 667.947 752.645 691.897 757.508 714.558L759.026 714.232C754.096 691.257 740.763 667.08 723.227 646.549C705.69 626.019 683.895 609.071 661.973 600.61L661.414 602.059ZM640.653 596.906C647.008 597.499 653.963 599.183 661.414 602.059L661.973 600.61C654.412 597.691 647.317 595.969 640.798 595.36L640.653 596.906ZM641.499 596.071C639.787 574.604 646.396 558.752 658.8 550.27C671.221 541.775 689.679 540.514 711.989 548.74L712.527 547.283C689.944 538.956 670.909 540.108 657.923 548.988C644.92 557.88 638.21 574.366 639.952 596.195L641.499 596.071ZM711.989 548.74C736.201 557.667 760.21 576.032 779.434 598.539C798.659 621.046 813.045 647.63 818.078 672.94L819.6 672.637C814.503 647.004 799.965 620.184 780.615 597.53C761.265 574.877 737.048 556.325 712.527 547.283L711.989 548.74ZM818.078 672.94C822.715 696.262 818.583 714.296 808.251 725.236C797.934 736.161 781.243 740.211 760.308 735.164L759.944 736.673C781.233 741.806 798.564 737.755 809.38 726.302C820.181 714.865 824.295 696.244 819.6 672.637L818.078 672.94Z",
    fill: "url(#paint5_linear_239_632)",
    fillOpacity: 0.3,
    mask: "url(#path-5-inside-1_239_632)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 683.921,
    cy: 607.633,
    rx: 166.668,
    ry: 161.287,
    transform: "rotate(-130.503 683.921 607.633)",
    fill: "url(#paint6_radial_239_632)",
    fillOpacity: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M486.895 458.569C582.42 376.974 726.662 389.037 809.068 485.512C891.474 581.987 880.839 726.34 785.314 807.935C689.789 889.53 545.548 877.467 463.142 780.993C380.736 684.518 391.371 540.164 486.895 458.569Z",
    fill: "url(#paint7_radial_239_632)",
    fillOpacity: 0.8
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M758.266 714.395C768.059 760.03 740.699 783.4 697.155 766.594C653.612 749.788 610.375 699.169 600.582 653.533C590.79 607.898 618.15 584.528 661.693 601.334C705.236 618.14 748.474 668.759 758.266 714.395Z",
    fill: "url(#paint8_radial_239_632)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M599.593 944.558C525.051 955.008 466.602 935.276 432.267 895.079C397.932 854.882 387.579 794.066 409.554 722.073C431.529 650.077 481.657 580.622 544.964 526.546C608.272 472.471 684.709 433.818 759.255 423.368C833.797 412.918 892.245 432.651 926.58 472.847C960.915 513.044 971.268 573.86 949.294 645.853C927.318 717.849 877.191 787.304 813.883 841.38C750.576 895.456 674.138 934.108 599.593 944.558Z",
    stroke: "url(#paint9_linear_239_632)",
    strokeWidth: 1.29394
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M591.112 935.056C516.449 945.523 457.801 925.768 423.319 885.399C388.836 845.029 378.493 784.014 400.503 711.905C422.513 639.795 472.706 570.262 536.071 516.138C599.435 462.014 675.96 423.308 750.624 412.841C825.287 402.375 883.935 422.129 918.417 462.499C952.9 502.868 963.243 563.883 941.233 635.992C919.223 708.102 869.03 777.635 805.666 831.76C742.301 885.884 665.776 924.59 591.112 935.056Z",
    stroke: "url(#paint10_linear_239_632)",
    strokeWidth: 0.258789
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M583.547 980.136C496.251 990.666 427.08 965.909 385.733 917.503C344.385 869.096 330.746 796.905 354.794 712.327C378.843 627.745 436.016 546.864 509.039 484.489C582.063 422.114 670.887 378.288 758.189 367.758C845.484 357.228 914.655 381.984 956.002 430.391C997.35 478.798 1010.99 550.989 986.942 635.566C962.893 720.149 905.719 801.03 832.696 863.405C759.672 925.78 670.848 969.606 583.547 980.136Z",
    stroke: "url(#paint11_linear_239_632)",
    strokeWidth: 1.29394
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M583.547 980.136C496.251 990.666 427.08 965.909 385.733 917.503C344.385 869.096 330.746 796.905 354.794 712.327C378.843 627.745 436.016 546.864 509.039 484.489C582.063 422.114 670.887 378.288 758.189 367.758C845.484 357.228 914.655 381.984 956.002 430.391C997.35 478.798 1010.99 550.989 986.942 635.566C962.893 720.149 905.719 801.03 832.696 863.405C759.672 925.78 670.848 969.606 583.547 980.136Z",
    stroke: "url(#paint12_linear_239_632)",
    strokeOpacity: 0.2,
    strokeWidth: 1.29394
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M575.785 971.013C485.076 977.539 411.392 947.545 365.535 893.859C319.678 840.173 301.572 762.706 322.198 674.131C342.827 585.548 398.284 502.673 471.298 440.306C544.311 377.94 634.837 336.121 725.554 329.594C816.264 323.068 889.948 353.062 935.805 406.748C981.662 460.434 999.768 537.902 979.142 626.477C958.513 715.06 903.056 797.935 830.042 860.301C757.029 922.667 666.503 964.486 575.785 971.013Z",
    stroke: "url(#paint13_linear_239_632)",
    strokeWidth: 1.29394
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.52859,
    height: 3.52859,
    transform: "matrix(0.0751674 -0.997171 0.996662 0.081644 552.622 616.851)",
    fill: "#00F0FF",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.45495,
    height: 1.45495,
    transform: "matrix(0.0751674 -0.997171 0.996662 0.081644 552.309 474.411)",
    fill: "#00F0FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.91074,
    height: 1.91074,
    transform: "matrix(-0.0751674 0.997171 0.996662 0.081644 839 448.48)",
    fill: "#00F0FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.20045,
    height: 2.20045,
    transform: "matrix(0.0751674 -0.997171 0.996662 0.081644 604.589 436.393)",
    fill: "#00F0FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.3041,
    height: 1.30409,
    transform: "matrix(0.0751674 -0.997171 0.996662 0.081644 611.005 468.501)",
    fill: "#00F0FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.52859,
    height: 3.52859,
    transform: "matrix(0.0751674 -0.997171 0.996662 0.081644 617.221 677.034)",
    fill: "#00F0FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.52859,
    height: 3.52859,
    transform: "matrix(0.0751674 -0.997171 0.996662 0.081644 515.096 739.464)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2.46612,
    height: 2.46612,
    transform: "matrix(0.0751674 -0.997171 0.996662 0.081644 486.267 630.894)",
    fill: "#3DFFFB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 4.58717,
    height: 4.58717,
    transform: "matrix(0.0751674 -0.997171 0.996662 0.081644 775.919 789.302)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 4.60278,
    height: 4.60278,
    transform: "matrix(-0.0751674 0.997171 0.996662 0.0816439 909.391 459.574)",
    fill: "#0066FF",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 4.89775,
    height: 4.89775,
    transform: "matrix(0.0751674 -0.997171 0.996662 0.0816439 901.518 881.658)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 3.42887,
    height: 3.42887,
    transform: "matrix(0.0751604 -0.997172 0.996661 0.0816509 925.712 762.27)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 6.37795,
    height: 6.37795,
    transform: "matrix(0.0751674 -0.997171 0.996662 0.0816439 939.93 805.156)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19483,
    height: 4.19482,
    transform: "matrix(-0.958756 -0.288878 0.282472 -0.957886 823.905 600.33)",
    fill: "#0066FF",
    fillOpacity: 0.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 3.27768,
    height: 3.28565,
    transform: "matrix(-0.997874 -0.0817507 0.0750689 -0.995962 743.551 544.267)",
    fill: "#00D1FF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 3.94219,
    height: 3.94219,
    transform: "matrix(0.958751 0.288895 0.282455 -0.957891 606.044 615.802)",
    fill: "#001AFF",
    fillOpacity: 0.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19483,
    height: 4.19483,
    transform: "matrix(-0.958751 -0.288895 0.282455 -0.957891 627.446 519.265)",
    fill: "#0066FF",
    fillOpacity: 0.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 4.19483,
    height: 4.19482,
    transform: "matrix(-0.958756 -0.288878 0.282472 -0.957886 909.696 565.405)",
    fill: "#0066FF",
    fillOpacity: 0.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 3.02911,
    height: 3.03648,
    transform: "matrix(-0.997874 -0.0817432 0.0750763 -0.995962 756.388 452.74)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 2.93476,
    height: 2.93476,
    transform: "matrix(-0.958758 -0.288871 0.282479 -0.957884 861.95 658.07)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 5.45886,
    height: 5.45886,
    transform: "matrix(-0.958751 -0.288895 0.282455 -0.957891 900.277 654.086)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 2.35062,
    height: 2.34951,
    transform: "matrix(0.0751602 -0.996936 0.996897 0.0816527 582.514 620.779)",
    fill: "#00FFF0",
    fillOpacity: 0.6
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 2.64823,
    height: 2.64699,
    transform: "matrix(0.0751499 -0.996937 0.996896 0.081663 562.352 775.789)",
    fill: "#00FFF0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 2.92397,
    height: 2.92259,
    transform: "matrix(-0.0751499 0.996937 0.996896 0.081663 473.108 590.138)",
    fill: "#00FFF0"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 3.11135,
    height: 3.10989,
    transform: "matrix(0.0751499 -0.996937 0.996896 0.081663 531.406 548.896)",
    fill: "#00FFF0"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 3.11135,
    height: 3.10989,
    transform: "matrix(0.0751421 -0.996937 0.996895 0.0816708 759.198 671.476)",
    fill: "#00FFF0",
    fillOpacity: 0.5
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 1.70562,
    height: 1.70481,
    transform: "matrix(0.0751499 -0.996937 0.996896 0.081663 678.45 708.41)",
    fill: "#00FFF0",
    fillOpacity: 0.5
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 3.11062,
    height: 3.11062,
    transform: "matrix(-0.514729 -0.860919 0.85676 -0.509739 622.922 813.465)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 2.17229,
    height: 2.17127,
    transform: "matrix(0.0751499 -0.996937 0.996896 0.081663 590.885 742.045)",
    fill: "#00D1FF",
    fillOpacity: 0.6
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 5.85384,
    height: 5.85109,
    transform: "matrix(0.0751499 -0.996937 0.996896 0.081663 612.25 759.516)",
    fill: "#6100FF",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.35062,
    height: 2.34951,
    transform: "matrix(0.0751497 -0.996937 0.996896 0.0816632 464.952 537.08)",
    fill: "#00FFF0",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.64823,
    height: 2.64699,
    transform: "matrix(0.0751588 -0.996936 0.996897 0.0816541 444.791 692.09)",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.92397,
    height: 2.92259,
    transform: "matrix(-0.0751497 0.996937 0.996896 0.0816632 355.547 506.442)",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.11135,
    height: 3.10989,
    transform: "matrix(0.0751419 -0.996937 0.996895 0.081671 413.844 465.197)",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.11135,
    height: 3.10989,
    transform: "matrix(0.0751497 -0.996937 0.996896 0.0816632 641.638 587.777)",
    fill: "#00FFF0",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70562,
    height: 1.70481,
    transform: "matrix(0.0751497 -0.996937 0.996896 0.0816632 560.889 624.711)",
    fill: "#00FFF0",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.11062,
    height: 3.11062,
    transform: "matrix(-0.51473 -0.860919 0.85676 -0.509739 505.363 729.766)",
    fill: "#0500FF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.17229,
    height: 2.17127,
    transform: "matrix(0.0751497 -0.996937 0.996896 0.0816632 473.324 658.346)",
    fill: "#00D1FF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.85384,
    height: 5.85109,
    transform: "matrix(0.0751456 -0.996937 0.996895 0.0816674 494.69 675.82)",
    fill: "#6100FF",
    fillOpacity: 0.5
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M752.105 779.762L747.876 758.08L768.631 765.646L772.86 787.329L752.105 779.762Z",
    fill: "url(#paint14_linear_239_632)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M768.631 765.649L747.876 758.082L731.243 797.581L768.631 765.649Z",
    fill: "url(#paint15_linear_239_632)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M768.631 765.652L772.885 787.329L731.243 797.585L768.631 765.652Z",
    fill: "url(#paint16_linear_239_632)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M598.563 594.119L595.894 580.438L608.99 585.213L611.659 598.894L598.563 594.119Z",
    fill: "url(#paint17_linear_239_632)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M608.993 585.211L595.894 580.435L585.397 605.363L608.993 585.211Z",
    fill: "url(#paint18_linear_239_632)",
    fillOpacity: 0.6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M608.991 585.211L611.676 598.89L585.396 605.363L608.991 585.211Z",
    fill: "url(#paint19_linear_239_632)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M509.727 485.102L505.168 462.512L526.868 470.264L531.427 492.854L509.727 485.102Z",
    fill: "url(#paint20_linear_239_632)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M526.868 470.269L505.167 462.516L488.086 503.834L526.868 470.269Z",
    fill: "url(#paint21_linear_239_632)",
    fillOpacity: 0.6
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M526.866 470.269L531.451 492.852L488.084 503.834L526.866 470.269Z",
    fill: "url(#paint22_linear_239_632)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M621.681 713.425L620.395 723.788L628.123 732.608L637.508 731.664L633.477 719.911L621.681 713.425Z",
    fill: "url(#paint23_linear_239_632)",
    fillOpacity: 0.7
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M595.193 752.085L623.509 744.534L636.307 742.815L595.193 752.085Z",
    fill: "url(#paint24_linear_239_632)",
    fillOpacity: 0.8
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M595.192 752.086L608.805 727.687L610.696 713.423L595.192 752.086Z",
    fill: "url(#paint25_linear_239_632)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M610.694 713.427L608.807 727.695L620.394 723.789L621.682 713.423L610.694 713.427Z",
    fill: "url(#paint26_linear_239_632)",
    fillOpacity: 0.6
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M623.508 744.532L608.808 727.692L620.397 723.785L628.124 732.604L623.508 744.532Z",
    fill: "url(#paint27_linear_239_632)",
    fillOpacity: 0.6
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M623.506 744.537L636.306 742.815L637.509 731.662L628.123 732.606L623.506 744.537Z",
    fill: "url(#paint28_linear_239_632)",
    fillOpacity: 0.8
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M595.193 752.085L629.7 723.876L636.307 742.815L595.193 752.085Z",
    fill: "url(#paint29_linear_239_632)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M595.192 752.085L629.698 723.875L610.696 713.421L595.192 752.085Z",
    fill: "url(#paint30_linear_239_632)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M636.305 742.816L629.7 723.875L633.477 719.908L637.507 731.668L636.305 742.816Z",
    fill: "url(#paint31_linear_239_632)",
    fillOpacity: 0.6
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M610.69 713.427L629.697 723.877L633.478 719.91L621.677 713.424L610.69 713.427Z",
    fill: "url(#paint32_linear_239_632)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_239_632",
    x1: 744.304,
    y1: 556.733,
    x2: 647.529,
    y2: 710.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165772,
    stopColor: "#71FFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#4F75FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E64FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_239_632",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(687.471 707.622) rotate(-78.1591) scale(121.067 144.739)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#3330B1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678936,
    stopColor: "#58FFFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_239_632",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(678.19 589.521) rotate(123.223) scale(153.767 264.832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298196,
    stopColor: "#5EF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538073,
    stopColor: "#3432BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914407,
    stopColor: "#171940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_239_632",
    x1: 673.44,
    y1: 579.458,
    x2: 635.34,
    y2: 744.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_239_632",
    x1: 740.717,
    y1: 574.176,
    x2: 727.1,
    y2: 689.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502014,
    stopColor: "#4FFFF4",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ECFFF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_239_632",
    x1: 729.522,
    y1: 523.683,
    x2: 748.316,
    y2: 783.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_239_632",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(683.921 619.065) rotate(80.719) scale(128.237 132.549)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0729167,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507801,
    stopColor: "#C173FF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E26FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_239_632",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(648.365 622.781) rotate(-49.5772) scale(180.754 182.811)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0729167,
    stopColor: "#8785FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E0EFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_239_632",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(606.85 768.165) rotate(-55.7832) scale(157.101 277.965)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3330B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_239_632",
    x1: 479.71,
    y1: 450.152,
    x2: 696.806,
    y2: 704.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FBCFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FBCFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_239_632",
    x1: 524.264,
    y1: 502.316,
    x2: 805.75,
    y2: 831.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FBCFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FBCFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_239_632",
    x1: 420.934,
    y1: 381.344,
    x2: 718.514,
    y2: 729.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#8FBCFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FBCFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_239_632",
    x1: 691.827,
    y1: 385.435,
    x2: 719.646,
    y2: 507.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF48D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234164,
    stopColor: "white",
    stopOpacity: 0.765836
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF48D7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_239_632",
    x1: 455.25,
    y1: 421.52,
    x2: 670.693,
    y2: 673.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FBCFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FBCFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_239_632",
    x1: 746.857,
    y1: 771.597,
    x2: 773.892,
    y2: 773.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6083FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1E5E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_239_632",
    x1: 753.198,
    y1: 755.275,
    x2: 730.941,
    y2: 797.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170794,
    stopColor: "#3D3BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537799,
    stopColor: "#FF7BE2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_239_632",
    x1: 731.391,
    y1: 797.758,
    x2: 771.06,
    y2: 784.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#9D50FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977116,
    stopColor: "#3DDCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_239_632",
    x1: 595.251,
    y1: 588.968,
    x2: 612.31,
    y2: 590.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6083FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1E5E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_239_632",
    x1: 599.253,
    y1: 578.664,
    x2: 585.207,
    y2: 605.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170794,
    stopColor: "#3D3BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537799,
    stopColor: "#FF7BE2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_239_632",
    x1: 585.489,
    y1: 605.472,
    x2: 610.524,
    y2: 597.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#9D50FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977116,
    stopColor: "#3DDCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_239_632",
    x1: 504.197,
    y1: 476.62,
    x2: 532.411,
    y2: 478.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6083FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1E5E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_239_632",
    x1: 510.7,
    y1: 459.552,
    x2: 487.767,
    y2: 503.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170794,
    stopColor: "#3D3BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537799,
    stopColor: "#FF7BE2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_239_632",
    x1: 488.24,
    y1: 504.014,
    x2: 529.531,
    y2: 490.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#9D50FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977116,
    stopColor: "#3DDCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_239_632",
    x1: 616.732,
    y1: 720.415,
    x2: 635.003,
    y2: 721.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6587FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E0FF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_239_632",
    x1: 620.866,
    y1: 730.156,
    x2: 634.514,
    y2: 754.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#89F8FF",
    stopOpacity: 0.934673
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#71F6FF",
    stopOpacity: 0.921354
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A72FF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_239_632",
    x1: 595.21,
    y1: 724.634,
    x2: 607.603,
    y2: 745.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170794,
    stopColor: "#3D3BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537799,
    stopColor: "#FF7BE2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_239_632",
    x1: 615.718,
    y1: 709.135,
    x2: 621.985,
    y2: 723.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#89F8FF",
    stopOpacity: 0.934673
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#71F6FF",
    stopOpacity: 0.921354
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A72FF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_239_632",
    x1: 613.358,
    y1: 723.805,
    x2: 607.989,
    y2: 739.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#89F8FF",
    stopOpacity: 0.934673
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#71F6FF",
    stopOpacity: 0.921354
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A72FF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_239_632",
    x1: 635.583,
    y1: 731.937,
    x2: 641.227,
    y2: 742.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#89F8FF",
    stopOpacity: 0.934673
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#71F6FF",
    stopOpacity: 0.921354
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A72FF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_239_632",
    x1: 608.15,
    y1: 766.985,
    x2: 615.251,
    y2: 729.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#9D50FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977116,
    stopColor: "#3DDCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_239_632",
    x1: 624.919,
    y1: 709.158,
    x2: 622.018,
    y2: 763.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170794,
    stopColor: "#3D3BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537799,
    stopColor: "#FF7BE2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_239_632",
    x1: 634.907,
    y1: 719.427,
    x2: 638.511,
    y2: 742.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#89F8FF",
    stopOpacity: 0.934673
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#71F6FF",
    stopOpacity: 0.921354
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A72FF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_239_632",
    x1: 617.28,
    y1: 721.141,
    x2: 629.129,
    y2: 711.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5ABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5ABE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonEclipse);
export default __webpack_public_path__ + "static/media/moon_eclipse.052eb61166e7819c9e1adba58c1f87f5.svg";
export { ForwardRef as ReactComponent };